import { useState } from 'react'
import { FormControl, MenuItem, Select } from '@achieve/ascend'
import { Typography } from 'components/Typography'
import { KeyboardArrowDown } from '@mui/icons-material'

export const DatSelectField = ({
  selectItemList = [
    { value: '20000', label: '$20,000' },
    { value: '30000', label: '$30,000' },
    { value: '40000', label: '$40,000' },
    { value: '50000', label: '$50,000' },
  ],
  onChange = () => {},
  defaultSelectedValue = '',
}) => {
  const [value, setValue] = useState(defaultSelectedValue || selectItemList?.[0]?.value)
  const selectItems = selectItemList.map(({ label, value }, idx) => (
    <MenuItem key={label} value={value} autoFocus={idx === 0}>
      <Typography
        fontWeight="bold"
        color="#3300ff"
        className="text-[28px]! font-extrabold! leading-[120%]!"
      >
        {label}
      </Typography>
    </MenuItem>
  ))
  return (
    <div className="w-full border-[3px] border-solid border-[rgb(51,0,255)] rounded-[8px]">
      <FormControl fullWidth>
        <Select
          displayEmpty
          IconComponent={KeyboardArrowDown}
          variant="standard"
          value={value}
          onChange={(e) => {
            onChange(e)
            setValue(e.target.value)
          }}
          fullWidth
          data-testid="dat-select-field"
          labelId="subtitle"
          className=" text-[28px]! text-[#3300ff] font-extrabold! [&_svg]:text-[rgb(51,0,255)] [&_svg]:mr-2.5 outline-hidden"
          sx={{
            border: 'none !important',
            svg: {
              color: 'rgb(51,0,255)', // Tailwind blue-500
              marginRight: '10px',
            },
            '&:before, &:after': {
              display: 'none',
            },
            '& .MuiInput-input:focus': {
              backgroundColor: 'transparent',
            },
          }}
        >
          {selectItems}
        </Select>
      </FormControl>
    </div>
  )
}
